
const OPTIONS = [
  {
    label: " Select",
    value: "select",
    disabled: true,
    content:
    {
      heading: "Closing the Gap",
      subheading: " Scenarios for Changing Mississippi's Future",
      text: "What would it take to close the gap and move Mississippi out of last place? There are many different ways to approach this question. Click through to see how different scenarios would impact Mississippi’s rankings among other states. Some changes would have a big impact on our rankings, some would barely change anything. Each scenario will “build a bridge” to illustrate how much of the gap would be closed.",
      percentage: 0,
      icon: "fa fa-percent"
    }
  },
  {
    label: " Education",
    value: "education",
    content:
    {
      heading: "Education",
      subheading: "25% Improvement Through 2040",
      text: "One of the biggest challenges our state faces is the lack of an educated workforce. By providing better educational choices for children in Mississippi, we can provide them the tools necessary to earn more as a member of the workforce later in life. Improving the earnings potential of our graduates by just 25% would close 66% of the gap over the next twenty years.",
      percentage: 66,
      icon: "fa fa-graduation-cap"
    }
  },
  {
    label: " Employment Rate",
    value: "employment",
    content:
    {
      heading: "Employment Rate",
      subheading: "Increase from 40% to 43% to Match Surrounding States",
      text: "The employment rate is defined as the percentage of Mississippians who are currently working. Mississippi’s employment rate is relatively low, when compared to the average employment rate of other “Bottom 5” states as well as our surrounding states. On average, fewer people in Mississippi are working than in these other states. Bringing more of these people into the workforce would have a significant impact on our ranking. Increasing our employment rate from 40% to 42% to match other “Bottom 5” states would close 70% of the gap, and increasing it to 43% to match surrounding states would close 72% of the gap.",
      percentage: 72,
      icon: "fa fa-thumbs-up"
    }
  },
  {
    label: " Wages and Salaries",
    value: "wages",
    content:
    {
      heading: "Wages and Salaries",
      subheading: "Increase By $37/Week (5%) To Match Surrounding States",
      text: "The wages and salaries earned by Mississippians is significantly lower than those in surrounding states, as well as in other “Bottom 5” states. Even a small increase in wages for workers across the state would close a sizable portion of the current gap. Increasing wages by 5%, or $37/week, would close 48% of the gap. An 8% increase in wages ($60/week) would close 77% of the gap.",
      percentage: 48,
      icon: "fa fa-money"
    }
  },
  {
    label: " Unemployment Rate",
    value: "unemployment",
    content:
    {
      heading: "Unemployment Rate",
      subheading: "Drops From 6.5% to 5.9% To Match Surrounding States",
      text: "The unemployment rate measures the number of unemployed people who are currently seeking work. While Mississippi’s unemployment rate is higher than many other states, our larger problem is the number of people not in the labor force and not currently seeking work. If Mississippi’s unemployment rate were lowered to match surrounding states or other “Bottom 5” states, this would only have a small impact on the gap.",
      percentage: 6,
      icon: "fa fa-thumbs-down"
    }
  },
  {
    label: " Income",
    value: "income",
    content:
    {
      heading: "Income",
      subheading: "Increases 1% For All Those Already Employed",
      text: "Increasing the income earned by individuals is the most direct way to look at increasing our per capita income and the well-being of those in the state. Because this represents all of the income earned by everyone in the state, relatively small percentage increases have a significant impact on our rankings. A 1% increase in income for those who are currently employed would close 22% of the gap, and a 3% increase would close 65% of the gap.",
      percentage: 17,
      icon: "fa fa-line-chart"
    }
  },
  {
    label: " Jobs",
    value: "jobs",
    content:
    {
      heading: "Jobs",
      subheading: "50,000 New “Typical/Average” Mississippi Jobs @ $18.08/Hour",
      text: "One way to measure the economic activity in our state is by the number of jobs. The average worker in Mississippi earns about $18/hour. If we could add 50,000 new jobs in our state at this average wage this would close about 61% of the gap.",
      percentage: 61,
      icon: "fa fa-industry"
    }
  },
  {
    label: " Disability",
    value: "disability",
    content:
    {
      heading: "Disability",
      subheading: "Drops From 7.9% to 7.2% To Match Surrounding States",
      text: "Mississippi has a larger disabled population than many other states. If we could move some of these people into productive work, it would improve our economic well-being. If we could employ some of these people and decrease our disabled population from 7.9% to 7.2% to match surrounding states, this would close 9% of the gap. Decreasing it to 6.4% to match other “Bottom 5” states would close 20% of the gap.",
      percentage: 9,
      icon: "fa fa-wheelchair"
    }
  },
  {
    label: " Rural vs. Urban",
    value: "rural",
    content:
    {
      heading: "Rural vs. Urban",
      subheading: "28% Of Rural Population Moves To Urban Areas To Match Surrounding States",
      text: "One challenge that Mississippi faces is the rural nature of our state. People who live in urban areas generally earn more than their rural counterparts. If Mississippi could encourage the development of our urban areas and some of the population shifted to urban work, it would help us move out of last place. If 28% of the rural population were to relocate for urban work to match our surrounding states, this would close 45% of the gap. If 32% of the rural population moved to match other “Bottom 5” states, this would close 51% of the gap.",
      percentage: 45,
      icon: "fa fa-building-o"
    }
  },
]

export default OPTIONS;



/** WEBPACK FOOTER **
 ** ./src/components/pages/OptionsData.js
 **/